var render = function render(){var _vm=this,_c=_vm._self._c;return _c('typo',{class:`territories ${_vm.mode}`,attrs:{"name":"body-12-medium","title":!_vm.isNational ? _vm.filteredTerritoryCodes.join(',') : ''}},[_vm._v(" "+_vm._s(_vm.dico[_vm.territoryRange])+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }